<div class="main-black border-radius-bottom white-box m-0 page-content">
	<div class="page-header px-4">
		<img src="/sctportal/images/BRM/brm-logo-vertical.png" alt="charglink BRM">
		<div class="horizontal-line mx-4">
		</div>
		<h1>{{'charglink_brm.title' | translate}}</h1>
		<div class="disable-buzzer"> <button class="btn btn-primary" (click)="toggleBuzzer()">{{(buzzerEnabled ? 'charglink_brm.disable_buzzer' : 'charglink_brm.enable_buzzer') | translate}}</button></div>
	</div>
</div>

<div class="table-container">
	<div class="filter-icon-container" *ngIf="hasDataToShow" (click)="showFilter = !showFilter">
		<fa-icon class="filter-icon" icon="filter" size="sm"></fa-icon>
	</div>
	<div class="row header-row">
		<div class="col-3 header-cell">
			<span>{{"charglink_brm.brm_group" | translate}}</span>
		</div>
		<div class="col-3 header-cell">
			<span>{{"charglink_brm.title" | translate}}</span>
		</div>
		<div class="col-3 header-cell">
			<span>{{"charglink_brm.location" | translate}}</span>
		</div>
		<div class="col-3 header-cell">
			<span>{{"charglink_brm.maintenance" | translate}}</span>
		</div>
	</div>

	<div class="filter-container" [class.show]="showFilter">
		<div class="d-flex">
			<div class="filter mr-3">
				<label for="groups">{{'charglink_brm.groups' | translate}}</label>
				<ng-select
					[(ngModel)]="filter.groupname"
					[items]="groupsList"
					name="groups"
					bindValue="id"
					bindLabel="name"
					[clearable]="false"
					[ngStyle]="{'width': '300px'}"
					(ngModelChange)="applyFilter()"
				></ng-select>
			</div>

			<!-- status -->
			<div class="filter mr-3">
				<label for="status">{{'g.status' | translate}}</label>
				<ng-select
					[(ngModel)]="filter.status"
					[items]="statusesList"
					name="status_filter"
					bindValue="id"
					bindLabel="name"
					[clearable]="false"
					[ngStyle]="{'width': '300px'}"
					(ngModelChange)="onStatusChange($event)"
				></ng-select>
			</div>

			<!-- is idle chargers -->
			<div class="filter mr-3">
				<label for="status">{{'charglink_brm.chargers_not_batteries_connected' | translate}}</label>
				<input type="checkbox"
					id="is_idle_chargers"
					[(ngModel)]="filter.showNotConnectedChargers"
					name="is_idle_chargers"
					[ngStyle]="{'width': '20px', 'height': '20px', display: 'block', 'margin-left': '5px'}"
					(ngModelChange)="toggleIdleChargers()"
				>
			</div>

			<!-- is unknown status chargers -->
			<div class="filter mr-3">
				<label for="status">{{'charglink_brm.chargers_unknown_status' | translate}}</label>
				<input type="checkbox"
					id="is_unknown_status_chargers"
					[(ngModel)]="filter.showUnknownChargers"
					name="is_unknown_status_chargers"
					[ngStyle]="{'width': '20px', 'height': '20px', display: 'block', 'margin-left': '5px'}"
					(ngModelChange)="toggleUnknownChargers()"
				>
			</div>
		</div>
	</div>

	<ng-container *ngFor="let key of toShowStatuses">
		<div class="row data-row" *ngFor="let data of filteredGroups[key]">
			<div class="col-3 data-cell">
				{{ data.name }}
			</div>
			<div class="col-3 data-cell status-cell justify-content-start">
				<div class="status-container">
					<img [src]="'/sctportal/images/BRM/' + batteryStatus[data.batteryStatus].image"
							[alt]="data.batteryStatus" />
					<span [style.color]="batteryStatus[data.batteryStatus].color">
						{{ batteryStatus[data.batteryStatus].value }}
					</span>
				</div>
			</div>
			<div class="col-3 data-cell">
				{{ data.location }}
			</div>

			<div class="col-3 data-cell" *ngIf="data.connected && ALLOWED_MAINTENANCE_STATUSES.includes(data.batteryStatus); else noMaintenance">
				<div class="maintenance-control">
					<button class="btn btn-primary maintenance-btn" (click)="confirmToggleMaintenance(data)">
						{{ (data.inMaintenance ? 'charglink_brm.exit_maintenance' : 'charglink_brm.move_to_maintenance') | translate}}
					</button>
				</div>
			</div>

			<ng-template #noMaintenance>
				<div class="col-3 data-cell"></div>
			</ng-template>

		</div>
	</ng-container>
</div>

<app-modal
	#maintenanceConfirmModal
	[title]="maintenanceConfirmTitleKey | translate"
	[message]="maintenanceConfirmMessageKey"
	[confirmBtnText]="'g.yes' | translate"
	[closeBtnText]="'g.no' | translate"
	[isWrappedText]="true"
></app-modal>
